import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export default class RetrieveExtPlatAccDataUseCase extends BaseUseCase {
    constructor(rRetrieveExtPlatAccRepo) {
        super();
        this.rRetrieveExtPlatAccRepo = rRetrieveExtPlatAccRepo;
    }
    async fetchResult() {
        return await this.rRetrieveExtPlatAccRepo.retrieveExtPlatAccData();
    }
}
